import { mapCssVariableToFallback } from './helpers';
export const theme = {
    background: {
        active: mapCssVariableToFallback('--wf-bg--active'),
        contrast: mapCssVariableToFallback('--wf-bg--contrast'),
        contrastInverse: mapCssVariableToFallback('--wf-bg--contrast-inverse'),
        focus: mapCssVariableToFallback('--wf-bg--focus'),
        hover: mapCssVariableToFallback('--wf-bg--hover'),
        hoverStrong: mapCssVariableToFallback('--wf-bg--hover-strong'),
        hoverStrongInverse: mapCssVariableToFallback('--wf-bg--hover-strong-inverse'),
        main: mapCssVariableToFallback('--wf-bg--main'),
        secondary: mapCssVariableToFallback('--wf-bg--secondary'),
        tertiary: mapCssVariableToFallback('--wf-bg--tertiary'),
        transparent: mapCssVariableToFallback('--wf-bg--transparent'),
        transparentInverse: mapCssVariableToFallback('--wf-bg--transparent-inverse'),
    },
    blue: {
        darker: mapCssVariableToFallback(`--wf-blue--darker`),
        lighter: mapCssVariableToFallback(`--wf-blue--lighter`),
        main: mapCssVariableToFallback(`--wf-blue--main`),
        text: mapCssVariableToFallback(`--wf-blue--text`),
        textOnColor: mapCssVariableToFallback(`--wf-blue--text-on-color`),
    },
    border: {
        focusOutline: mapCssVariableToFallback('--wf-border-color--focus-outline'),
        interactive: mapCssVariableToFallback('--wf-border-color--interactive'),
        main: mapCssVariableToFallback('--wf-border-color--main'),
        strong: mapCssVariableToFallback('--wf-border-color--strong'),
    },
    boxShadow: {
        medium: mapCssVariableToFallback('--wf-box-shadow--medium'),
        thick: mapCssVariableToFallback('--wf-box-shadow--thick'),
        thin: mapCssVariableToFallback('--wf-box-shadow--thin'),
        xthick: mapCssVariableToFallback('--wf-box-shadow--xthick'),
    },
    brand: {
        darker: mapCssVariableToFallback('--wf-brand--darker'),
        lighter: mapCssVariableToFallback('--wf-brand--lighter'),
        main: mapCssVariableToFallback('--wf-brand--main'),
        text: mapCssVariableToFallback('--wf-brand--text'),
        textOnColor: mapCssVariableToFallback('--wf-brand--text-on-color'),
        textSubtle: mapCssVariableToFallback('--wf-brand--text-subtle'),
    },
    error: {
        darker: mapCssVariableToFallback(`--wf-error--darker`),
        lighter: mapCssVariableToFallback(`--wf-error--lighter`),
        main: mapCssVariableToFallback(`--wf-error--main`),
        text: mapCssVariableToFallback(`--wf-error--text`),
        textOnColor: mapCssVariableToFallback(`--wf-error--text-on-color`),
        transparent: mapCssVariableToFallback(`--wf-error--transparent`),
    },
    green: {
        darker: mapCssVariableToFallback(`--wf-green--darker`),
        lighter: mapCssVariableToFallback(`--wf-green--lighter`),
        main: mapCssVariableToFallback(`--wf-green--main`),
        text: mapCssVariableToFallback(`--wf-green--text`),
        textOnColor: mapCssVariableToFallback(`--wf-green--text-on-color`),
    },
    grey: {
        darker: mapCssVariableToFallback(`--wf-grey--darker`),
        lighter: mapCssVariableToFallback(`--wf-grey--lighter`),
        main: mapCssVariableToFallback(`--wf-grey--main`),
        subtler: mapCssVariableToFallback(`--wf-grey--subtler`),
        text: mapCssVariableToFallback(`--wf-grey--text`),
        textOnColor: mapCssVariableToFallback(`--wf-grey--text-on-color`),
    },
    info: {
        darker: mapCssVariableToFallback(`--wf-info--darker`),
        lighter: mapCssVariableToFallback(`--wf-info--lighter`),
        main: mapCssVariableToFallback(`--wf-info--main`),
        text: mapCssVariableToFallback(`--wf-info--text`),
        textOnColor: mapCssVariableToFallback(`--wf-info--text-on-color`),
        transparent: mapCssVariableToFallback(`--wf-info--transparent`),
    },
    navy: {
        darker: mapCssVariableToFallback(`--wf-navy--darker`),
        lighter: mapCssVariableToFallback(`--wf-navy--lighter`),
        main: mapCssVariableToFallback(`--wf-navy--main`),
        subtler: mapCssVariableToFallback(`--wf-navy--subtler`),
        text: mapCssVariableToFallback(`--wf-navy--text`),
        textOnColor: mapCssVariableToFallback(`--wf-navy--text-on-color`),
    },
    orange: {
        darker: mapCssVariableToFallback(`--wf-orange--darker`),
        lighter: mapCssVariableToFallback(`--wf-orange--lighter`),
        main: mapCssVariableToFallback(`--wf-orange--main`),
        text: mapCssVariableToFallback(`--wf-orange--text`),
        textOnColor: mapCssVariableToFallback(`--wf-orange--text-on-color`),
    },
    pink: {
        darker: mapCssVariableToFallback(`--wf-pink--darker`),
        lighter: mapCssVariableToFallback(`--wf-pink--lighter`),
        main: mapCssVariableToFallback(`--wf-pink--main`),
        text: mapCssVariableToFallback(`--wf-pink--text`),
        textOnColor: mapCssVariableToFallback(`--wf-pink--text-on-color`),
    },
    purple: {
        darker: mapCssVariableToFallback(`--wf-purple--darker`),
        lighter: mapCssVariableToFallback(`--wf-purple--lighter`),
        main: mapCssVariableToFallback(`--wf-purple--main`),
        text: mapCssVariableToFallback(`--wf-purple--text`),
        textOnColor: mapCssVariableToFallback(`--wf-purple--text-on-color`),
    },
    red: {
        darker: mapCssVariableToFallback(`--wf-red--darker`),
        lighter: mapCssVariableToFallback(`--wf-red--lighter`),
        main: mapCssVariableToFallback(`--wf-red--main`),
        text: mapCssVariableToFallback(`--wf-red--text`),
        textOnColor: mapCssVariableToFallback(`--wf-red--text-on-color`),
    },
    success: {
        darker: mapCssVariableToFallback(`--wf-success--darker`),
        lighter: mapCssVariableToFallback(`--wf-success--lighter`),
        main: mapCssVariableToFallback(`--wf-success--main`),
        text: mapCssVariableToFallback(`--wf-success--text`),
        textOnColor: mapCssVariableToFallback(`--wf-success--text-on-color`),
        transparent: mapCssVariableToFallback(`--wf-success--transparent`),
    },
    text: {
        inverse: mapCssVariableToFallback('--wf-text--inverse'),
        inverseSubtle: mapCssVariableToFallback('--wf-text--inverse-subtle'),
        link: mapCssVariableToFallback('--wf-text--link'),
        main: mapCssVariableToFallback('--wf-text--main'),
        secondary: mapCssVariableToFallback('--wf-text--secondary'),
        subtle: mapCssVariableToFallback('--wf-text--subtle'),
    },
    transparentGrey: {
        darker: mapCssVariableToFallback(`--wf-transparent-grey--darker`),
        lighter: mapCssVariableToFallback(`--wf-transparent-grey--lighter`),
        main: mapCssVariableToFallback(`--wf-transparent-grey--main`),
        subtler: mapCssVariableToFallback(`--wf-transparent-grey--subtler`),
        text: mapCssVariableToFallback(`--wf-transparent-grey--text`),
        textOnColor: mapCssVariableToFallback(`--wf-transparent-grey--text-on-color`),
    },
    upgrade: {
        darker: mapCssVariableToFallback(`--wf-upgrade--darker`),
        lighter: mapCssVariableToFallback(`--wf-upgrade--lighter`),
        main: mapCssVariableToFallback(`--wf-upgrade--main`),
        text: mapCssVariableToFallback(`--wf-upgrade--text`),
        textOnColor: mapCssVariableToFallback(`--wf-upgrade--text-on-color`),
        transparent: mapCssVariableToFallback(`--wf-upgrade--transparent`),
    },
    warning: {
        darker: mapCssVariableToFallback(`--wf-warning--darker`),
        lighter: mapCssVariableToFallback(`--wf-warning--lighter`),
        main: mapCssVariableToFallback(`--wf-warning--main`),
        text: mapCssVariableToFallback(`--wf-warning--text`),
        textOnColor: mapCssVariableToFallback(`--wf-warning--text-on-color`),
        transparent: mapCssVariableToFallback(`--wf-warning--transparent`),
    },
    white: {
        main: mapCssVariableToFallback(`--wf-white--main`),
        text: mapCssVariableToFallback(`--wf-white--text`),
        textOnColor: mapCssVariableToFallback(`--wf-white--text-on-color`),
    },
    yellow: {
        darker: mapCssVariableToFallback(`--wf-yellow--darker`),
        lighter: mapCssVariableToFallback(`--wf-yellow--lighter`),
        main: mapCssVariableToFallback(`--wf-yellow--main`),
        text: mapCssVariableToFallback(`--wf-yellow--text`),
        textOnColor: mapCssVariableToFallback(`--wf-yellow--text-on-color`),
    },
};
